// extracted by mini-css-extract-plugin
module.exports = {"barSpinner":"BarSpinner_barSpinner__cEuR1","bar":"BarSpinner_bar__13K3Z","wave":"BarSpinner_wave__HJE1k"};